import { render } from "./LoginOto.vue?vue&type=template&id=01510944&scoped=true"
import script from "./LoginOto.vue?vue&type=script&lang=js"
export * from "./LoginOto.vue?vue&type=script&lang=js"

import "./LoginOto.vue?vue&type=style&index=0&id=01510944&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01510944"]])

export default __exports__